export const isSafari = navigator.vendor.includes('Apple');